import classnames from "classnames";
import React from "react";
import DryerIcon from "@/assets/icons/dryer.svg";
import GamingIcon from "@/assets/icons/gaming.svg";
import GuaranteesIcon from "@/assets/icons/guarantees.svg";
import MobileIcon from "@/assets/icons/mobile.svg";
import ProtectPlusIcon from "@/assets/icons/protect-plus.svg";
import SmallAppliancesIcon from "@/assets/icons/small-appliances.svg";
import TVIcon from "@/assets/icons/tv.svg";
import OptionButton from "@/components/option-button/OptionButton";
import styles from "./screens.module.scss";

const getHref = next => `/guarantees-and-troubleshooting-guides?dt=${next}`;

const links =
  process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === "prod"
    ? {
        tv: "https://productsupport.johnlewis.com/customer/category/TelevisionAudio",
        mobile: "https://productsupport.johnlewis.com/customer/category/MobilesCamerasSmartTech",
        gaming: "https://productsupport.johnlewis.com/customer/category/ComputingGaming",
        homeAppliances: "https://productsupport.johnlewis.com/customer/category/HomeAppliances",
        appliancesAndVacuums: "https://productsupport.johnlewis.com/customer/category/SmallAppliancesVacuums",
      }
    : {
        tv: "https://johnlewiscustomer-uat.lucidcx.com/customer/category/TelevisionAudio",
        mobile: "https://johnlewiscustomer-uat.lucidcx.com/customer/category/MobilesCamerasSmartTech",
        gaming: "https://johnlewiscustomer-uat.lucidcx.com/customer/category/ComputingGaming",
        homeAppliances: "https://johnlewiscustomer-uat.lucidcx.com/customer/category/HomeAppliances",
        appliancesAndVacuums: "https://johnlewiscustomer-uat.lucidcx.com/customer/category/SmallAppliancesVacuums",
      };

const MainScreen = () => {
  return (
    <div className={styles.container}>
      <div className={styles.esiContainer}>
        <div className={classnames("util-dividerWithText", styles.hideOnMobile)}>Guarantees</div>
        <p className={styles.sectionText}>
          We offer outstanding guarantees in addition to always honouring the manufacturers' guarantees. All our
          guarantees are in addition to your statutory rights.
        </p>
        <div className={classnames(styles.row, styles.mainRow)}>
          <OptionButton
            className={classnames(styles.optionButton4, styles.guaranteesContainer)}
            title="Guarantees"
            imgSrc={GuaranteesIcon}
            imgContainerClassName={styles.mainImageContainer}
            imgClassName={styles.mainImage}
            href={getHref("guarantees")}
          />
          <OptionButton
            className={classnames(styles.optionButton4, styles.protectPlusContainer)}
            title="Protect Plus Accidental Damage Insurance"
            contentClassName={styles.protectPlusContent}
            imgSrc={ProtectPlusIcon}
            imgClassName={styles.protectPlusImage}
            href="https://www.johnlewis.com/our-services/protect-plus"
          />
        </div>
        <div className="util-dividerWithText">
          Electrical troubleshooting guides & support
        </div>
        <p className={styles.sectionText}>
          Select from the categories below to search for guidance and information about your electrical product.
        </p>
        <div className={styles.row}>
          <OptionButton
            className={styles.optionButton4}
            title="Television and audio"
            imgSrc={TVIcon}
            imgContainerClassName={styles.mainImageContainer}
            imgClassName={styles.mainImage}
            href={links.tv}
          />
          <OptionButton
            className={styles.optionButton4}
            title="Computing &amp; gaming"
            imgSrc={GamingIcon}
            imgContainerClassName={styles.mainImageContainer}
            imgClassName={styles.mainImage}
            href={links.gaming}
          />
          <OptionButton
            className={styles.optionButton4}
            title="Home appliances"
            imgSrc={DryerIcon}
            imgContainerClassName={styles.mainImageContainer}
            imgClassName={styles.mainImage}
            href={links.homeAppliances}
          />
        </div>
        <div className={styles.row}>
          <OptionButton
            className={styles.optionButton4}
            title="Mobile, cameras &amp; smart tech"
            imgSrc={MobileIcon}
            imgContainerClassName={styles.mainImageContainer}
            imgClassName={styles.mainImage}
            href={links.mobile}
          />
          <OptionButton
            className={styles.optionButton4}
            title="Small appliances &amp; vacuums"
            imgSrc={SmallAppliancesIcon}
            imgContainerClassName={styles.mainImageContainer}
            imgClassName={styles.mainImage}
            href={links.appliancesAndVacuums}
          />
        </div>
      </div>
    </div>
  );
};

export default MainScreen;
